{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "actualSituation": "Mövcud vəziyyət",
    "payments": "Ödənişlər",
    "totalAmount": "Ümumi məbləğ",
    "currentAccount": "Hazırkı hesab"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "disable-tfa": {
    "label": {
      "title": "İki faktorlu autentifikasiyanı qeyri-fəallaşdır (2FA)",
      "disable": "2FA-nı qeyri-fəallaşdır"
    },
    "validations": {},
    "message": {
      "alert-1": "Bu hərəkət yalnız 2FA-nı qeyri-fəal edir.",
      "alert-2": "2FA-nın qeyri-fəallaşdırılması authenticator proqramlarında istifadə olunan açarları dəyişmir. ",
      "alert-3": "Əgər authenticator proqramında istifadə olunan açarı dəyişmək istəyirsinizsə, mütləq:",
      "alert-4": "tanıtıcı açarlarınızı sıfırlayın.",
      "success": "2fa əlil olub. Authenticator proqramı qurduqda 2fa-nı yenidən bərpa edə bilərsiniz"
    }
  },
  "menu": {
    "label": {
      "security": "Təhlükəsizlik",
      "users": "İstifadəçilər",
      "apikey": "Açar",
      "twoFactorAuthentication": "İki Faktor autentifikasiyası",
      "configuration": "Quraşdırma",
      "notifications-application": "Bildirişlər Tətbiqi",
      "notifications-security": "Təhlükəsizlik haqqında bildirişlər",
      "environment-application": "Ətraf mühit tətbiqi",
      "environment-security": "Ətraf Mühit Təhlükəsizliyi",
      "operations": "Gedişlər",
      "economy-activity": "İqtisadiyyatın fəaliyyəti",
      "catalog": "Kataloq növü",
      "taxpayer-fields": "Vergi ödəyicilərinin sahələri",
      "taxes": "Vergilər",
      "manage-tax": "Vergiləri İdarə Et"
    }
  },
  "common": {
    "label": {
      "theme": "Tema",
      "captcha-placeholder": "Captcha daxil ol",
      "feedback": "Geribildirim",
      "logout": "Logout",
      "print": "Çap Et",
      "phoneNumberArea": "Ərazi",
      "current-user": "Hazırkı istifadəçi",
      "user-profile": "İstifadəçi profili",
      "name": "Ad",
      "givenNames": "Adlar",
      "surnames": "Soyadlar ",
      "search": "Axtar",
      "clean": "Təmiz",
      "create": "Yarat",
      "ok": "Yaxşı",
      "next": "Sonrakı",
      "cancel": "Ləğv etmək",
      "back": "Geri",
      "edit": "_Düzəlt",
      "actions": "Hərəkət",
      "send": "Göndər",
      "close": "Bağla",
      "add": "Əlavə Et",
      "email": "E-poçt",
      "phoneNumber": "Telefon Nömrəsi",
      "id": "Id",
      "password": "Şifrə",
      "state": "Söndür",
      "translation": "Tərcümə",
      "language": "Dil",
      "value": "Qiymət",
      "translatable": "Translatable",
      "politicalDivision": "Siyasi parçalanma",
      "department": "Şöbə/Provice/Dövlət",
      "city": "Şəhər",
      "zipCode": "Indeks",
      "cellPhone": "Mobil telefon",
      "personType": "Şəxs növü",
      "businessName": "İş adı",
      "taxpayerName": "Tam Adı və ya İş Adı",
      "tradeName": "Ticarət adı",
      "address": "Ünvan",
      "country": "Ölkə",
      "localization": "Yerliləşdirmə",
      "website": "Veb Sayt",
      "fileSearch": "Fayl axtar",
      "fileUpload": "Fayl yüklə",
      "fileDownload": "Faylı yüklə",
      "noFileSelected": "Seçili fayl yoxdur",
      "fileRequirements": "PDF · Maks. 9,6 MB",
      "fileUploading": "Yüklənir...",
      "fileUploaded": "Yükləndi",
      "fileUploadError": "Fayl yüklənə bilmədi",
      "fileSelect": "Seçin",
      "fileReplace": "Əvəz edin",
      "fileRemove": "Sil",
      "fileRemoving": "Silinir...",
      "fileRemoveError": "Fayl silinə bilmədi",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "noFound": "Nəticə yoxdur",
      "taxReturnCurrency": "Taxreturn Döviz",
      "page-showing": "Göstər",
      "page-to": "to",
      "page-of": "of",
      "page-entries": "Girişlər",
      "loading": "Yüklənir...",
      "error": "Xəta",
      "unableToLoad": "Məlumatları yükləmək mümkün olmadı. Zəhmət olmasa yenidən cəhd edin.",
      "retry": "Yenidən cəhd edin",
      "currency": "Pul vahidi",
      "paymentMethod": "Ödəniş üsulu",
      "attachment": "Ilişdir",
      "paymentReference": "Ödəniş referenti",
      "supportDocument": "Dayaq sokun",
      "payment": "Ödəniş",
      "backToHome": "Evə qayıt",
      "bank": "Bank",
      "bankInformation": "Bank məlumatı",
      "excel": "Excel",
      "days": {
        "monday": "Mo",
        "tuesday": "Tu",
        "wednesday": "Biz",
        "thursday": "Th",
        "friday": "Fr",
        "saturday": "Sa",
        "sunday": "Su"
      },
      "months": {
        "january": "Yanvar",
        "february": "Fevral",
        "march": "Mart",
        "april": "Aprel",
        "may": "May",
        "june": "İyun",
        "july": "İyul",
        "august": "Avqust",
        "september": "Sentyabr",
        "october": "Oktyabr",
        "november": "Noyabr",
        "december": "Dekabr"
      }
    },
    "descriptions": {
      "taxReturnCurrency": "Taxreturns üçün istifadə edilən pul vahidi",
      "contactTaxIdNumber-tax": "Əlaqə vergisinin identifikasiya nömrəsi"
    },
    "button": {
      "add": "Əlavə Et",
      "edit": "_Düzəlt",
      "find": "Axtar",
      "cancel": "Ləğv etmək",
      "delete": "Sil",
      "save": "Qeyd Et",
      "submitTaxReturn": "Vergi bəyannaməsini təqdim et",
      "clean": "Təmizlə",
      "new": "Yeni",
      "show": "Göstər",
      "download": "Endir",
      "file": "Ilişdir",
      "previous": "Əvvəlki",
      "next": "Sonrakı",
      "send": "Göndər",
      "translate": "Tərcümə əlavə et",
      "return": "Qayıt",
      "continue": "Davam Et",
      "newVersion": "Yeni versiya"
    },
    "dialog": {
      "dialog-error": "Səhvlər",
      "table-title-header": "İsmarışlar",
      "warning-title": "Diqqət"
    },
    "messages": {
      "error-500": "Oops, bir şey səhv getdi",
      "fileUpload": "Fayl uğurla yükləndi",
      "fileUploadMaxSize": "Sənəd böyüklüyü 10Mb-dən çox ola bilməz",
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib",
      "deletedSucessfully": "Müvəffəqiyyətlə silindi",
      "pleaseWait": "Xahiş edirəm gözləyin",
      "warningInactiveSession": "Diqqət! Bir müddət ərzində heç bir fəaliyyət aşkar edilməyib. Hələlik heç bir fəaliyyət aşkar olunmasa, iclas 1 dəqiqə ərzində bağlanacaq",
      "sessionIdleCountdown": "Sessiyanız {{count}} saniyə sonra bağlanacaq.",
      "closingSession": "İclası Bağla ...",
      "warningCancelOperation": "Əməliyyatı ləğv etsəniz daxil olan məlumatları itirəcəksiniz. Davam etmək istəyirsiniz?",
      "confirm": "Əminsinizmi ki, bu hərəkəti etmək istəyirsiniz?",
      "feedback": "Geribildiriminiz üçün təşəkkür edirəm",
      "feedbackIntro": "Sistemlə bağlı təcrübənizi bilmək və sizə daha yaxşı xidmət göstərə bilmək üçün şərhləriniz Administrasiyaya göndəriləcək.",
      "messageSent": "İsmarış müvəffəqiyyətlə göndərildi"
    },
    "validations": {
      "nameRequired": "Sahə Adı tələb olunur",
      "fieldRequired": "Sahə tələb olunur",
      "mapRequired": "Xəritədə mövqeyi seçməlisiniz",
      "numbersAndLetters": "Yalnız rəqəmlər və hərflər",
      "email": "Səhv e-poçt",
      "minStringValue": "Sahə ən azı {{min}} hərf olmalıdır",
      "maxStringValue": "Sahə ən çox {{max}} hərflərində olmalıdır",
      "minNumberValue": "Sahə dəyəri ən azı {{min}} olmalıdır",
      "maxNumberValue": "Sahə dəyəri ən çox {{max}} olmalıdır",
      "urlInvalid": "Url formatı səhvdir",
      "captchaValidationRequired": "Captcha doğruluğu tələb olunur"
    },
    "languages": {
      "spanish": "İspan dili (İspaniya)",
      "english": "İngilis dili (Amerika Birləşmiş Ştatları)"
    },
    "taxpayer-request-types": {
      "enroll": "Qeydlər",
      "update": "Yenilə"
    },
    "taxpayer-request-states": {
      "pending": "Gözlənilməkdə",
      "pending_additional_information": "Əlavə Məlumat Gözləyən",
      "approved": "Təsdiq edilmiş",
      "rejected": "Rədd Edildi"
    },
    "taxreturn-types": {
      "original": "Orijinal",
      "amending": "Düzəliş"
    },
    "taxreturn-status": {
      "pending": "Gözlənilməkdə",
      "accepted": "Qəbul Edildi",
      "approved": "Təsdiq edilmiş",
      "rejected": "Rədd Edildi",
      "reconciled": "Barışdı"
    },
    "yes-no": {
      "yes": "Bəli",
      "no": "Xeyr"
    }
  },
  "administration-user": {
    "title": {
      "page": "İstifadəçilər",
      "page-taxpayer": "Vergi ödəyiciləri"
    },
    "label": {
      "userName": "İstifadəçi Adı",
      "department": "Şöbə",
      "roles": "Rollar",
      "user": "Yeni istifadəçi",
      "disabled": "Söndür",
      "locale": "Üstünlük verilmiş dil",
      "disable": "Fəallaşdır",
      "enable": "Fəallaşdır",
      "cancel": "Ləğv etmək"
    },
    "validations": {
      "userName": "İstifadəçi Adı tələb olunur"
    },
    "messages": {
      "disableTitle": "İstifadəçini bağla",
      "confirmDisable": "Bu istifadəçini qeyri-fəal etmək istədiyinizdən əminsiniz?",
      "confirmEnable": "Bu istifadəçini fəal etmək istədiyinizdən əminsiniz?",
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib",
      "enableTitle": "İstifadəçini fəallaşdır",
      "error": "Xəta"
    }
  },
  "user-profile": {
    "title": {
      "page": "İstifadəçi Profili",
      "change-password": "Şifrəni Dəyiş"
    },
    "label": {
      "userName": "İstifadəçi Adı",
      "name": "Tam Adı",
      "email": "E-poçt",
      "locale": "Üstünlük verilmiş dil",
      "currentPassword": "Hazırkı şifrə",
      "newPassword": "Şifrə",
      "repeatPassword": "Şifrəni təkrarla",
      "change-password": "Şifrəni Dəyiş",
      "password": "parol"
    },
    "message": {
      "password-changed": "Şifrə uğurla dəyişdirildi",
      "profile-updated": "Profil uğurla yeniləndi. Dəyişiklikləri görmək üçün logout edilməlidir",
      "password": "Hesabınızı təhlükəsiz saxlamaq üçün hesab parolunuzu yeniləyin"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Gələnlər Qutusu"
    },
    "label": {
      "message": "İsmarış:",
      "messages": "İsmarışlar",
      "read": "Oxu",
      "inboxDate": "Tarix",
      "ok": "Yaxşı",
      "no": "XEYR"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Yenidən qurulur",
      "reconected": "Yenidən bərpa edildi"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Kataloq növü",
      "catalog": "Kataloq "
    },
    "label": {
      "type": "Növ",
      "name": "Ad",
      "description": "İzah",
      "field": "Sahə",
      "label": "etiket",
      "parent": "Valideyn",
      "newCatalogType": "Yeni kataloq növü",
      "newCatalog": "Yeni kataloq",
      "code": "Kod",
      "addDefinition": "Tərif əlavə et",
      "newDefinition": "Yeni tə'rif",
      "extaFilds": "İstifadəçi əlavə sahələri",
      "addNameTraslation": "Tərcümə əlavə et"
    },
    "validations": {
      "exists": "Qeyd onsuz da mövcuddur",
      "letterNumberhyphen": "Hərflərin sayı və tireləri icazə verilir"
    },
    "messages": {
      "languageExist": "Dil artıq əlavə edilib"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Vergi ödəyicilərinin sahələri",
      "enabled": "Fəal"
    },
    "header": {
      "fieldCode": "Kod",
      "fieldName": "Sahə Adı",
      "fieldSection": "Bölmə Adı",
      "actions": "Fəal"
    },
    "messages": {
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib"
    }
  },
  "security-apikey": {
    "title": {
      "page": "Açarlar"
    },
    "label": {
      "name": "Ad",
      "new-api-key": "Yeni Açar",
      "expiration": "İstifadə müddəti",
      "your-pat": "Yeni Şəxsi Giriş Nişanınız",
      "revoke-token": "Nişan"
    },
    "validations": {
      "name": "Api Açar Adı tələb olunur",
      "expiration": "Müddətin bitmə tarixi tələb olunur"
    },
    "message": {
      "key-created": "Əmin olun ki, onu xilas edin - bir də daxil ola bilməyəcəksiniz.",
      "confirm-revoke": "Əminsinizmi ki, nişanı ləğv etmək istəyirsiniz?"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Tanıtıcı proqramını quraşdır",
      "verification-code": "Yoxlama Kodu",
      "verification-code-digit": "{{position}} / {{total}} rəqəm",
      "verify": "Təsdiqlə",
      "manual-key": "Əl ilə quraşdırma açarı",
      "copy-key": "Açarı kopyala",
      "key-copied": "Açar buferə kopyalandı.",
      "key-copied-button": "Kopyalandı",
      "copy-unavailable": "Açarı kopyalamaq mümkün olmadı. Onu əl ilə kopyalayın.",
      "security-recommendations": "Təhlükəsizlik tövsiyələri",
      "security-recommendations-detail": "Bərpa kodlarını təhlükəsiz yerdə saxlayın və quraşdırma açarını paylaşmayın."
    },
    "validations": {
      "code": "Yoxlama Kodu tələb olunur"
    },
    "message": {
      "instruction-1": "Microsoft Authenticator kimi iki fakturalı authenticator proqramını yükləyin",
      "and": "və",
      "or": "və ya",
      "for": "üçün",
      "instruction-2": "QR Kodu skan edin və ya bu açarı daxil edin",
      "instruction-3": "iki fakturalı authenticator proqramınıza daxil olun. Boşluq və kasanın əhəmiyyəti yoxdur.",
      "instruction-4": " Qr kodu skan etdikdən və ya yuxarıda açarı daxil etdikdən sonra, iki faktor təsdiqləmə proqramınız sizə unikal kod təqdim edəcək. Kodu aşağıdakı təsdiq qutusuna daxil edin."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Bərpa kodları",
      "available-once": "İndi yadda saxlayın: onlar yenidən tam şəkildə göstərilməyəcək."
    },
    "message": {
      "save-security-codes": "Bu kodları təhlükəsiz yerə qoyun.",
      "if-you-lose": "Cihazınızı itirsəniz və bərpa kodlarına sahib olmasanız hesabınıza girişi itirəcəksiniz."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "İki faktorlu autentifikasiya (2FA) bərpa kodlarını generasiya edin",
      "generate": "Recovery Codes-ləri generasiya edin"
    },
    "validations": {},
    "message": {
      "alert-1": "Bu kodları təhlükəsiz yerə qoyun.",
      "alert-2": " Cihazınızı itirsəniz və bərpa kodlarına sahib olmasanız hesabınıza girişi itirəcəksiniz.",
      "alert-3": "Yeni bərpa kodlarının əmələ gəlməsi authenticator proqramlarında istifadə olunan açarları dəyişmir. Authenticator proqramında istifadə olunan açarı dəyişmək istəyirsinizsə, etməlisiniz",
      "alert-4": "tanıtıcı açarlarınızı sıfırlayın."
    }
  },
  "security-login": {
    "title": {
      "login": "Giriş"
    },
    "label": {
      "username": "İstifadəçi Adı",
      "password": "Şifrə",
      "rememberMe": "Xatırla məni",
      "loginButton": "Giriş",
      "passwordRecovery": "Şifrəni geri qaytar",
      "notRegistered": "Hələ qeydiyyatdan keçməyib ?",
      "signup": "İndi imza at",
      "loginAlternative": "və ya",
      "forgotPassword": "Şifrəni unutdun?",
      "next": "Sonrakı",
      "forgotPasswordInstructions": "İstifadəçi adınızı daxil edin və biz sizə onu geri almaq üçün ətraflı təlimatlarla məktub göndərəcəyik",
      "externalLogin": "Xarici Giriş",
      "captcha-placeholder": "Captcha daxil ol"
    },
    "validations": {
      "usernameRequired": "Sahə İstifadəçi adı tələb olunur",
      "passwordRequired": "Sahə Şifrəsi tələb olunur",
      "captchaValidationRequired": "Captcha doğruluğu tələb olunur"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "İki faktorlu autentifikasiya",
      "login-recovery": "Recovery kodun yoxlanılması"
    },
    "label": {
      "twoFactorCode": "Təsdiqləyici kodu",
      "recoveryCode": "Bərpa kodu",
      "rememberBrowser": "Bu səyyahı yadda saxla",
      "verificationCodeInstructions": "Davam etmək üçün autentifikator tətbiqinizdəki altı rəqəmli kodu daxil edin.",
      "loginButton": "Giriş",
      "loginRecovery": "Recovery kodu ilə giriş"
    },
    "message": {
      "no-access": " Autentifikasiya cihazınıza giriş yoxdur? Sən bacararsan",
      "trustedBrowser": "Bu etibarlı brauzerdə doğrulamanı keçin.",
      "recovery-requested": " Siz bərpa kodu ilə daxil olmaq üçün xahiş etdik. 2FA-da log in və ya disable-də authenticator proqram kodu təqdim etməyincə və yenidən daxil olmayınca bu giriş yadda olmayacaq."
    },
    "validations": {
      "twoFactorCode": "Sahə Autentifikasiya kodu tələb olunur",
      "recoveryCode": "Sahə Recovery kodu tələb olunur"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Şifrəni Geri Qaytar",
      "changePassword": "Şifrəni dəyiş",
      "userName": "İstifadəçi Adı",
      "newPassword": "Şifrə",
      "repeatPassword": "Şifrəni təkrarla",
      "returnLogin": "Girişə qayıt"
    },
    "message": {
      "email-sended": "Şifrə e-poçtunu geri qaytar",
      "password-changed": "Şifrə uğurla dəyişdirildi"
    },
    "validations": {
      "newPassword": "Yeni şifrə ən azı 6 hərf olmalıdır",
      "passwordEqual": "Şifrə uyğun gəlmir"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Qurğu autentifikasiya proqramı",
      "reset": "Tanıtıcı açarı sıfırla",
      "configure": "Tanıtıcı proqramını quraşdır"
    },
    "validations": {},
    "message": {
      "alert-1": "Authenticator açarınızı sıfırlasanız, authenticator proqramınızı yenidən quraşdırmayıncə işləməyəcəksiniz.",
      "alert-2": "Bu proses 2FA-nı authenticator proqramınızı yoxlayana qədər qeyri-fəal edir.",
      "alert-3": "Authenticator proqram konfiqurasiyasını tamamlamasanız hesabınıza girişinizi itirə bilərsiniz.",
      "success": "Authenticator app açarınız sıfırlanıb, yeni açardan istifadə edərək authenticator proqramınızı konfiqurasiya etmək lazım gələcək."
    }
  },
  "tfa": {
    "title": {
      "page": "İki Faktor autentifikasiyası"
    },
    "label": {
      "title": "İki faktorlu autentifikasiya (2FA)",
      "authenticator-app": "Tanıtma proqramı",
      "setup-authenticator": "Qurğu autentifikasiya proqramı",
      "add-authenticator": "Tanıtma proqramını əlavə et",
      "reset-authenticator": "Tanıtıcı proqramını sıfırla",
      "reset-recovery-codes": "Bərpa kodlarını sıfırla",
      "disable-2fa": "2FA-nı qeyri-fəallaşdır",
      "forget-this-browser": "Bu brauzeri unut",
      "status-enabled": "Aktiv",
      "status-disabled": "Konfiqurasiya edilməyib",
      "recovery-codes-remaining": "bərpa kodu mövcuddur",
      "danger-zone": "Yüksək təsirli əməliyyatlar"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Hazırkı brauzer unudulub. Bu brauzerdən yenidən daxil olduqda 2fa kodunuz sizə təlqin olunacaq.",
      "no-codes-left-1": "Sizin bərpa kodlarınız qalmayıb.",
      "no-codes-left-2": "Məcbursan",
      "no-codes-left-3": "yeni bərpa kodları dəsti yaradır",
      "no-codes-left-4": "bərpa kodu ilə daxil olmazdan əvvəl.",
      "some-codes-left-1": "Sənin var",
      "some-codes-left-2": "bərpa kodları qaldı.",
      "some-codes-left-3": "Gərək ",
      "some-codes-left-4": "yeni bərpa kodları dəsti yaradır"
    }
  },
  "roles": {
    "account_reports": "Hesab hesabatları",
    "catalogs_admin": "Kataloq administratoru",
    "details_reports": "Ətraflı Hesabatlar",
    "environments_admin": "Ətraf Mühit İdarəçisi",
    "forms_admin": "Form İdarəçisi",
    "management_report_admin": "İdarəetmə Hesabatları Administratoru",
    "notifications_admin": "Bildirişlər İdarəçisi",
    "system_auditor": "Sistem Auditoru",
    "taxpayer_reports": "Vergi ödəyicisinin hesabatları",
    "taxpayers_admin": "Vergi ödəyiciləri İdarəçisi",
    "payments_admin": "Ödəniş meneceri",
    "taxpayers_approver": "Vergi ödəyicilərinin təsdiq edən",
    "taxreturn_approver": "Taxreturn Təsdiq edən",
    "taxreturn_reports": "Taxreturn hesabatları",
    "tfa_admin": "2FA Administrator",
    "users_admin": "İstifadəçi administratoru",
    "current_account_admin": "Hazırkı Hesab İdarəsi"
  },
  "report-file": {
    "title": {
      "page": "Ilişdirmə Suplementary hesabatı",
      "dialog": "Hesabat onsuz da mövcuddur",
      "dialog-confirm": "Hesabat göndər"
    },
    "label": {
      "header": "Başlıq",
      "description": "İzah",
      "type": "Növ",
      "file": "Suplementar hesabat",
      "loading": "Yüklənir...",
      "definition": "Təsnifat faylı (.csv,.xls,.xlsx)"
    },
    "button": {
      "attachment": "İlişən mə'lumat"
    },
    "messages": {
      "dialog": "Artıq seçilmiş dövr üçün hesabat təqdim edilib. Mövcud hesabatı yeni versiya ilə əvəz etmək istəyirsiniz?",
      "confirm": "Əminsinizmi ki, bu hərəkəti etmək istəyirsiniz?",
      "successfully": "[createDate] -də dövr [period] ilə vergi hesabatı uğurla göndərildi",
      "backToHome": "Evə qayıt"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "İşləmə",
      "error": "Xəta",
      "accepted": "Qəbul Edildi",
      "processed": "İşlənmiş"
    },
    "title": {
      "page": "Hesabat təfsilatları"
    },
    "label": {
      "reportNumber": "Hesabat nömrəsi",
      "reportType": "Hesabat növü",
      "operations": "Əməliyyat növü",
      "taxpayerNumber": "Vergi ödəyicilərinin sayı",
      "taxpayerName": "Vergi ödəyicisi Adı",
      "registrationDate": "Raqistrasiya Tarixi",
      "period": "Dövr",
      "reportName": "Hesabat Adı",
      "record": "Qeyd",
      "index": "indeks",
      "type": "Növ",
      "active": "Fəal",
      "taxReportState": "Ştat"
    }
  },
  "report-selection": {
    "label": {
      "fileReport": "Fayl hesabatı",
      "report": "Hesabat",
      "year": "Dövr"
    },
    "messages": {
      "reportVersionNotFound": "Rapor versiyası tapılmadı"
    }
  },
  "taxreturn-report": {
    "title": {
      "page": "Taxreturn hesabatları"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "Taxreturn sayı",
      "country": "Ölkə",
      "formId": "Forma",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "name": "Vergi ödəyicisinin adı",
      "period": "Dövr",
      "periodFrom": "Dövr",
      "periodTo": "Dövr",
      "active": "Fəal",
      "overview": "Ümumi baxış",
      "taxreturn": "Taxreturn",
      "createDate": "Tarix Yarat",
      "approve": "Təsdiq edilmiş",
      "comments": "Şərh"
    },
    "header": {
      "actions": "Hərəkət",
      "nit": "TIN",
      "name": "Vergi ödəyicisinin adı",
      "taxReturnNumber": "Taxreturn sayı",
      "createDate": "Tarix Yarat",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "form": "Forma",
      "period": "Dövr",
      "active": "Fəal",
      "rejectionReason": "Rədd edilmənin səbəbi"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "form-cells": {
    "title": {
      "page": "Hüceyrələr",
      "serviceParameters": "Xidmət Parametrləri"
    },
    "label": {
      "code": "Hüceyrə kodu",
      "name": "Hüceyrə adı",
      "description": "İzah",
      "section": "Bölmə",
      "formula": "Formula",
      "order": "Sifariş",
      "type": "Növ",
      "service": "Xidmət",
      "mandatory": "Mütləq",
      "editable": "Düzəldilə bilən",
      "visible": "Görünən",
      "cellPurpose": "Xana məqsədi",
      "numeric": "Say",
      "currency": "Pul vahidi",
      "date": "Tarix",
      "list": "Siyahı",
      "text": "Mətn",
      "catalogType": "Kataloq növü",
      "parameterName": "Ad",
      "addParameter": "Parametri əlavə et"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Onu mütləq silərsiniz?"
    }
  },
  "amendment-create": {
    "title": {
      "dialog-confirm": "Vergi Məcəlləsini Göndər"
    },
    "label": {
      "taxReturn": "Taxreturn düzəlişə"
    },
    "messages": {
      "confirm": "Əminsinizmi ki, bu hərəkəti etmək istəyirsiniz?"
    }
  },
  "statement-submit-amendment": {
    "title": {
      "page": "File taxreturn düzəlişi"
    },
    "label": {
      "taxReturn": "Vergilərin qaytarılması",
      "year": "Dövr"
    },
    "messages": {},
    "validations": {},
    "button": {
      "file": "File taxreturn düzəlişi"
    }
  },
  "statement-submit-statement": {
    "title": {
      "page": "Vergi bəyannaməsini təqdim edin",
      "subtitle": "Bəyan ediləcək vergi və dövrü müəyyən etmək üçün məlumatları tamamlayın"
    },
    "label": {
      "fileStatement": "Fayl vergisi",
      "taxReturn": "Vergilərin qaytarılması",
      "year": "Dövr"
    },
    "messages": {
      "formVersionNotFound": "Hazırkı və aktiv versiya tapılmadı",
      "taxReturnExist": "Artıq bu dövr üçün taksreturn mövcuddur",
      "validPeriod": "Seçili dövr bu vergi üçün keçərli deyil"
    }
  },
  "taxreturns": {
    "title": {
      "dialog-confirm": "Vergi Məcəlləsini Göndər"
    },
    "messages": {
      "successfully": "[period] dövrü ilə vergi geri qaytarılması [createDate] uğurla göndərildi",
      "successfullyApprovalRequired": "Düzəliş bəyannaməsi vergini azaltdığından vergi administrasiyasının razılığı və ya rədd edilməsi üçün təkrar baxılma prosesinə təqdim ediləcək.",
      "confirm": "Əminsinizmi ki, bu hərəkəti etmək istəyirsiniz?",
      "backToHome": "Evə qayıt"
    }
  },
  "taxes": {
    "title": {
      "page": "Vergiləri İdarə Et"
    },
    "label": {
      "name": "Ad",
      "rateType": "Qiymət növü",
      "shortName": "Qısa Ad",
      "code": "Kod",
      "newButton": "Yeni",
      "saveButton": "Qeyd Et",
      "tabEditTax": "Ümumi",
      "tabRates": "Qiymətlər",
      "tabPeriodicity": "Dövrilik",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "value": "Qiymət",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü"
    },
    "header": {
      "code": "Kod",
      "name": "Ad",
      "rateType": "Qiymət növü",
      "value": "Qiymət",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "shortName": "Qısa Ad",
      "actions": "Hərəkət",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü"
    },
    "validations": {
      "rateTypeRequired": "Sahə Qiymət Növü tələb olunur",
      "shortNameRequired": "Sahə Qısa adı tələb olunur",
      "codeRequired": "Sahə Kodu tələb olunur",
      "valueLessThan100": "Sahə Dəyəri 100% -dən az olmalıdır",
      "valueRequired": "Sahə Dəyəri tələb olunur",
      "dateFromRequired": "\"Tarixdən\" sahəsi tələb olunur",
      "dateToRequired": "\"Date To\" sahəsi tələb olunur",
      "filingDueDayRequired": "Sahənin müddəti başa çatması günü tələb olunur",
      "periodicityTypeRequired": "Sahə Periodiklik Növü tələb olunur"
    },
    "messages": {
      "savedSuccessfully": "Müvəffəqiyyətlə qeyd edilib",
      "deletedSuccessfully": "Müvəffəqiyyətlə silindi",
      "error": "Xəta"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Hesabat Əməliyyatlarını İdarə Et",
      "warning": "Xəbərdarlıq"
    },
    "label": {
      "operation": "Əməliyyat",
      "report": "Hesabat"
    },
    "header": {
      "operation": "Əməliyyat",
      "report": "Hesabat",
      "actions": "Hərəkət"
    },
    "messages": {
      "removeReportOperation": "Onu mütləq silərsiniz?"
    }
  },
  "report-cells": {
    "title": {
      "page": "Hüceyrələr"
    },
    "label": {
      "code": "Hüceyrə kodu",
      "name": "Hüceyrə adı",
      "description": "İzah",
      "formula": "Formula",
      "order": "Sifariş",
      "type": "Növ",
      "numeric": "Numizmatika",
      "currency": "Pul vahidi",
      "date": "Tarix",
      "list": "Siyahı",
      "text": "Mətn",
      "catalogType": "Kataloq növü"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Əminsinizmi ki, silmək istəyirsiniz?"
    }
  },
  "reports": {
    "title": {
      "page": "Hesabatları İdarə Et",
      "report": "Hesabat",
      "versions": "Tərcümələr"
    },
    "label": {
      "name": "Ad",
      "shortName": "Qısa Ad",
      "code": "Kod",
      "newButton": "Yeni",
      "saveButton": "Qeyd Et",
      "tabEditReport": "Ümumi",
      "tabPeriodicity": "Dövrilik",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü"
    },
    "header": {
      "code": "Kod",
      "name": "Ad",
      "shortName": "Qısa Ad",
      "actions": "Hərəkət",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü"
    },
    "validations": {
      "shortNameRequired": "Sahə Qısa adı tələb olunur",
      "codeRequired": "Sahə Kodu tələb olunur",
      "dateFromRequired": "\"Tarixdən\" sahəsi tələb olunur",
      "dateToRequired": "\"Date To\" sahəsi tələb olunur",
      "filingDueDayRequired": "Sahənin müddəti başa çatması günü tələb olunur",
      "periodicityTypeRequired": "Sahə Periodiklik Növü tələb olunur"
    },
    "messages": {
      "savedSuccessfully": "Müvəffəqiyyətlə qeyd edilib",
      "deletedSuccessfully": "Müvəffəqiyyətlə silindi",
      "error": "Xəta"
    }
  },
  "form-administration": {
    "title": {
      "page": "Vergi Bəyannaməsi Forması İdarəsi ",
      "form": "Forma",
      "versions": "Tərcümələr"
    },
    "label": {
      "code": "Kod",
      "name": "Ad",
      "shortName": "Qısa ad",
      "tax": "Vergi",
      "numberModifications": "Nömrə Dəyişmləri",
      "amendmentApprovalRequired": "Düzəlişin təsdiq edilməsi tələb olunur",
      "form": "Formalar",
      "versions": "Tərcümələr"
    },
    "header": {
      "actions": "Hərəkət",
      "code": "Kod",
      "name": "Ad",
      "shortName": "Qısa ad",
      "tax": "Vergi"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Siz mütləq silinirsiniz?",
      "noCellDefined": "Hörmətli vergi ödəyicisi bu forma natamam tərifə malikdir, administratora müraciət edin"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Hazırkı Hesab",
      "amendingCredit": "Balans sorğusu",
      "currentAccountTransaction": "Əməliyyat detalları",
      "transactionAdjustment": "Tərəzi düzəlişi"
    },
    "label": {
      "tax": "Vergi",
      "taxCode": "Vergi kodu",
      "period": "Dövr",
      "taxAmount": "Vergi məbləği",
      "penalty": "Cəza",
      "interest": "Maraqlar",
      "taxArrears": "Vergiyə görə vergilər",
      "total": "ümumi",
      "expirationDate": "Qurtarmə tarixi",
      "accountType": "Hesab növü",
      "balance": "Tarazlı",
      "date": "Tarix",
      "transactionType": "Transaksiya növü",
      "value": "Qiymət",
      "document": "Sənəd",
      "justification": "Bəraət qazandır",
      "credit": "Kredit",
      "debit": "Debet"
    },
    "dialog": {},
    "messages": {},
    "validations": {}
  },
  "taxpayer-payments": {
    "title": {
      "page": "Ödəniş sorğusu",
      "pagePayments": "Ödəniş rekordu",
      "selectTaxReturn": "VergiNin qaytarılmasını seçin"
    },
    "label": {
      "registerPayment": "Ödəniş rekordu",
      "amountTaxReturn": "Deklarasiya məbləği",
      "totalDebt": "Total debt",
      "tax-id": "Verginin müəyyənləşdirilməsi",
      "name": "Ad",
      "date-from": "Tarix",
      "date-to": "Tarix:",
      "date-payment": "Ödəmə tarixi",
      "payment-number": "Ödəniş nömrəsi",
      "exchange-rate": "Valyuta məzənnəsi.",
      "local-amount": "Yerli valyutada məbləğ",
      "tax": "Vergi",
      "amount": "Miqdar",
      "swiftNumber": "Swift təsdiq nömrəsi"
    },
    "messages": {
      "paymentRegisteredSucessfully": "[createDate] saytında ödəniş uğurla qeydiyyata alındı",
      "paymentInformationWarning": "Si les informations concernant le code Swift ne sont pas renseignées, le paiement ne pourra pas être correctement identifié et la déclaration sera considérée impayée"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Vergi ödəyicisinin hesabatı"
    },
    "label": {
      "name": "Ad",
      "nit": "TIN",
      "county": "Ölkə",
      "personType": "Şəxs növü",
      "email": "E-poçt"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Kəs",
      "businessName": "İş adı",
      "fullName": "Tam adı",
      "id": "İdentifikasiya nömrəsi",
      "taxNumber": "Vergi nömrəsi",
      "phoneNumber": "Telefon nömrəsi",
      "domicile": "Domicile",
      "department": "Şöbə/Provice/Dövlət",
      "addContact": "Əlaqə əlavə et",
      "operations": "Gedişlər",
      "contacts": "Üzvlər",
      "taxVector": "Vergi vekselin",
      "reportVector": "Hesabat",
      "generalData": "Ümumi",
      "tax": "Vergi",
      "taxObligation": "Vergi",
      "report": "Hesabat",
      "website": "Veb-sayt",
      "idTax": "İdentifikasiya vergi nömrəsi",
      "contactName-tax": "Yaşayış yeri üzrə ölkə ərazisində əlaqə adı",
      "docNumberContact-tax": "Yaşayış yeri üzrə ölkə üzrə əlaqənin sənəd nömrəsi",
      "contactTaxIdNumber-tax": "Əlaqə vergisinin identifikasiya nömrəsi",
      "phoneNumberContact-tax": "Yaşayış yeri üzrə ölkə ərazisində əlaqənin telefon nömrəsi",
      "email-tax": "E-Mail ilə əlaqə saxlayın",
      "documents": "Sənədlər",
      "docCompanyRegistrationNumber": "Şirkətin qeydiyyat sənədi",
      "docLocalContact": "Yerli əlaqə qeydiyyatlı şəxsiyyət",
      "acceptance": "Qəbul",
      "taxpayerRequest": "POSS Qeydiyyatı",
      "confirmTerms": "Şərt və şərtləri qəbul etmək",
      "terms": "Lorem ipsum dolor sit amet consectetur adipiscing elit per, penatibus euismod ac libero praesent sollicitudin lacinia nulla platea, nam hac cursus cubilia congue luctus dapibus. Iaculis luctus egestas accumsan eleifend metus dis aptent quisque, lacus vitae nullam habitasse ad mollis tempor, mattis ornare dapibus laoreet auctor tellus dui. Ante integer sagit erat accumsan vulputate potenti senectus, rutrum ullamcorper nam hendrerit ridiculus faucibus, parturient fames ligula venenatis tristique inceptos.\n\nCum aliquet tempor cras non potenti inceptos aptent, mauris scelerisque mollis auctor libero porta id ut, sodales vulputate eget imperdiet netus posuere. Iaculis dignissim himenaeos magna luctus nulla egestas porttitor, eros vulputate volutpat sociosqu quisque mollis donec, class placerat justo vivamus imperdiet accumsan. Ultrices facilisi phasellus augue cursus etiam viverra suspendisse est, nam vulputate tempor posuere dignissim feugiat sed hac sodales, diam tristique pretium auctor ad erat sem. Et enim gravida magnis malesuada nam nascetur fermentum, proin platea elementum nec penatibus ultricies, blandit cubilia aptent neque praesent sociis.\n\nSagittis augue enim nam sociis, ornare est mi himenaeos, risus proin sodales. Proin malesuada integer aliquam cubilia neque natoque velit, feugiat elementum quis quisque suscipit fermentum conubia, nisi a ligula duis sapien tellus. Praesent mattis fringilla habitant nulla sollicitudin bibendum habitasse at cum quis mus iaculis mi magna sodales, velit hendrerit inceptos dictum neque montes turpis tellus nam morbi commodo nullam senectus.\n\nArcu primis eu conubia fusce nisi vehicula posuere leo sollicitudin eleifend, phasellus sodales congue ligula consequat volutpat magnis facilisi curabitur maecenas, et dis velit libero hac proin habitant sociis nascetur. Nunc tortor penatibus mi ultrices risus nec elementum justo, mattis ad ac tempus vel habitasse accumsan sed parturient, lectus lacinia conubia malesuada volutpat egestas nulla. Himenaeos consequat vitae class mattis taciti nec habitant eleifend, elementum netus eget parturient suspendisse porttitor in felis maecenas, curabitur morbi odio gravida vivamus per bibendum.\n\nTortor non sociosqu accumsan orci vel ligula risus nisl, penatibus odio magnis ullamcorper pellentesque habitant lacinia consequat, aptent nec congue nisi egestas sociis quam. Turpis sociis eu est parturient in fames aliquet nisl, dui natoque phasellus aliquam posuere curae aptent porta, tortor condimentum molestie netus cubilia inceptos lacinia. Auctor laoreet purus nostra dapibus sollicitudin tincidunt dictum nisl lacinia erat, est rhoncus fusce phasellus blandit etiam inceptos suspendisse magna, duis pellentesque nam hac neque musnissim a enim.\n\nNeque proin felis laoreet senectus nullam netus sollicitudin odio tincidunt, penatibus parturient facilisis porta duis sagittis malesuada varius sociosqu congue, aptent velit pellentesque mauris egestas nibh semper orci. Torquent nec commodo erat eu pharetra natoque, senectus velit nascetur curae sollicitudin mus phasellus. Aenean diam ut nibh vulputat neque fusce penatibus class porta mattis imperdiet risus ante, ac lectus habitasse posuere facilisis luctus varius mus tempus non mollis.\n\nDictumst eleifend vehicula purus hendrerit volutpat primis integer, per senectus fusce nulla cubilia dictum feugiat auctor, ultricies sociosqu nisl mi class magnis. Ligula himenaeos phasellus pulvinar accumsan platea egestas sodales hendrerit sagittis augue, curae nec molestie pretium cum parturient lacus euismod sociosqu ullamcorper duis, dignissim fusce libero maecenas congue lobortis penatibus nisi justo.\n\nCum rutrum vehicula convallis pellentesque maecenas nascetur proin congue platea, posuere neque facilisi ullamcorper nibh curae sodales non, cursus nisl cras morbi interdum vitae auctor cubilia. Ligula taciti enim donec congue bibendum fusce eros rhoncus suscipit, dui parturient potenti odio sapien non erat eget, tincidunt convallis primis quam tortor consequat sodales per. Neque hendrerit erat nunc hac ullamcorper molestie fermentum, tristique ultrices sociis vivamus volutpat lectus, vestibulum vehicula aenean mattis magna posuere. Justo condimentum tempor taciti laoreet inceptos per hendrerit eleifend consequat lacus nostra enim, convallis praesent dui faucibus lobortis quam pharetra odio mauris duis.\n\nMagna ultrices dui netus laoreet odio rhoncus maecenas nec placerat rutrum, massa duis nam nulla velit quis fringilla habitasse. Eu integer diam lectus ullamcorper torquent ante aliquet cras feugiat inceptos placerat ut, porta libero nam mauris volutpat habitasse iaculis lacinia facilisi hendrerit nostra.\n\nLaoreet risus nisi sociosqu inceptos maecenas blandit phasellus bibendum, nostra velit fringilla tristique mus donec lectus semper, est tortor nascetur curae scelerisque himenaeos sagittis. Quam volutpat eros non nec nascetur justo, velit tristique nisl arcu est, ultricies sapien convallis metus vulputate. Kondimentum justo ad varius habitant nunc gravida sed vivamus, maecenas ut congue aenean ligula proin lectus, natoque urna duis dui semper egestas habitasse.\n\nAnte et luctus porta malesuada accumsan cursus senectus dictumst penatibus pretium nullam, id condimentum proin felis aliquam sollicitudin varius velit lobortis class placerat, praesent ridiculus eget nisl metus tristique maecenas semper himenaeos parturient. Enim laoreet vulputat orci dui lectus purus bibendum vivamus posuere est curabitur, cubilia fames nulla porta in scelerisque cursus nunc a ligula pretium dictum, mi molestie pulvinar torquent litora vitae fusce eget curae sem. Dapibus quam facilisi cras pharetra mus curabitur, parturient a malesuada integer vitae etiam suspendisse, fermentum massa libero curae neque.",
      "locale": "Üstünlük verilmiş dil",
      "close": "Bağla",
      "acquirerId": "Məsabiqə İD",
      "acquirerCountry": "Məsabiqənin ölkəsi",
      "terminalId": "Terminal İD",
      "merchantCategoryCode": "Təcəssümçü kateqoriya kodu",
      "merchantId": "Təcəssümçü İD",
      "documentNumberCountryResidence": "Yaşadığı ölkənin sənəd nömrəsi"
    },
    "vector": {
      "label": {
        "tax": "Vergi",
        "expiration": "Müddətin bitmə günü",
        "periodicity": "Dövrilik",
        "startOperation": "Əməliyyat Başla"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Ən azı bir əlaqə tələb olunur",
      "operations": "Ən azı bir əməliyyat tələb olunur",
      "selectOperations": "müvafiq əməliyyatları seçin",
      "withoutOperations": "Heç bir əməliyyat yoxdur",
      "withoutOperationsVector": "Seçilmiş əməliyyatlarınız üçün təqdim etmək üçün vergi vektorunuz yoxdur",
      "withoutOperationsReport": "Seçili əməliyyatlarınız üçün təqdim etməli hesabatlarınız yoxdur",
      "withoutDocuments": "Heç bir fayl tərifi yoxdur",
      "successRegistrationTaxpayerTitle": "Sizin qeydiyyat istəyiniz başa çatdı və təslim olaraq alındı.",
      "successRegistrationTaxpayerSubTitle": "Təhlil olunacaq və siz onların nəticələrini poçt vasitəsilə əldə edəcək",
      "email-tax-info": "Təsdiq edildikdən sonra bu e-poçt istifadəçi adınızı və şifrənizi almaq üçün istifadə olunacaq sənin tələbin. Təqdim olunan məlumatların düzgünlüyünü yoxlayın",
      "contactsList": "İkinci dərəcəli əlaqələrinizi burada qeydiyyatdan keçirin. Ən azı birini qeydiyyatdan keçirməlisiniz",
      "noContacts": "Heç bir əlaqə qeydiyyatdan keçməyib"
    },
    "validations": {
      "acceptance": "Sahə yoxlanmalıdır",
      "formComplete": "Bütün formanı tamamla"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Vergi ödəyicilərinin müraciətləri",
      "approve": "Xahişləri qəbul etmək",
      "reject": "rədd cavabı",
      "request-additional-info": "Əlavə məlumat istə"
    },
    "label": {
      "date-from": "Tarix",
      "date-to": "Tarix",
      "request-type": "İstinad növü",
      "request": "İstinad",
      "type": "Növ",
      "taxpayer": "Vergi ödəyicisi",
      "state": "Ştat",
      "approve": "Təsdiqlə",
      "reject": "Rədd Et",
      "request-additional-info": "Əlavə məlumat istə",
      "comments": "Şərh",
      "reason": "Səbəb",
      "cancellationDate": "İmtina tarixi"
    },
    "message": {
      "approved": "Xahiş qəbul edilib",
      "rejected": "Xahiş Rədd Edildi",
      "request-additional-info": "Əlavə məlumat istənildi",
      "unsubscribe-request": "Müraciətiniz qəbul edildi, müraciətiniz təsdiq olundusa və ya rədd edilərsə, sizə xəbər veriləcək."
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Bəyannamə hesabatlarına baxın",
      "subtitle": "Saxlanılan sənədlərin siyahısı",
      "amendment": "Vergi bəyannaməsinə düzəliş təqdim edin"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "Taxreturn sayı",
      "country": "Ölkə",
      "formId": "Forma Adı",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "name": "Vergi ödəyicisinin adı",
      "period": "Dövr",
      "periodFrom": "Dövr",
      "periodTo": "Dövr",
      "active": "Fəal",
      "overview": "Ümumi baxış",
      "taxreturn": "Taxreturn",
      "createDate": "Tarix Yarat",
      "approve": "Təsdiq edilmiş",
      "comments": "Şərh"
    },
    "header": {
      "actions": "Hərəkət",
      "nit": "TIN",
      "name": "Vergi ödəyicisinin adı",
      "taxReturnNumber": "Taxreturn sayı",
      "createDate": "Tarix Yarat",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "form": "Forma",
      "period": "Dövr",
      "active": "Fəal",
      "rejectionReason": "Rədd edilmənin səbəbi"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Yenilənmə qeydiyyatı"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Qeydsizlər"
    }
  },
  "taxpayer-alternate-user": {
    "title": {
      "page-add": "Yeni alternativ istifadəçi",
      "page-list": "Alternativ istifadəçilər"
    },
    "label": {
      "add-user": "İstifadəçi əlavə et"
    }
  },
  "login": {
    "hero": {
      "title": "Dünyada Vergilərin Çətinlikləri Üçün Modernləşmə və Əməkdaşlıq",
      "name": "Rəqəmsal İqtisadiyyat"
    },
    "block1": {
      "title": "Strateji Platforma",
      "text": "Vergi Administrasiyaları üçün"
    },
    "block2": {
      "title": "Effektiv Bir Vasitə",
      "text": "Yurisdiksiyada Fiziki Təmsilçiliyi Olmayan Şirkətlərin Vergilənməsinin İdarə Edilməsi üçün."
    },
    "block3": {
      "title": "Asanlaşdırmaq üçün hazırlanmışdır",
      "text": "Xarici Rəqəmsal Təchizatçılar tərəfindən Vergilərin Qeydiyyatı, Təqdim Edilməsi və Ödənilməsi."
    },
    "links": {
      "title": "Əlavə Məlumat",
      "link1": "Materiallar və Prosedurlar",
      "link2": "CIAT haqqında",
      "link3": "PITAA haqqında"
    }
  },
  "appMenu": {
    "taxpayer-profile-update": "Qeydiyyatı yeniləyin",
    "taxpayer-payment-view": "Ödənişlərə baxın",
    "taxpayer-payment-record": "Ödəniş qeydi",
    "unsubscribe-request-taxpayer": "Abunəni dayandırın",
    "taxpayer-amending-credit": "Borc Balansı",
    "security-taxpayer": "Təhlükəsizlik",
    "apikey": "Api açarları",
    "two-factor-authentication-taxpayer": "İki faktorlu autentifikasiya",
    "taxpayer-profile": "Profil",
    "inbox-notifications": "Bildirişlər",
    "file-tax-statements": "Vergi bəyannaməsini təqdim edin",
    "statements": "Vergi bəyannamələri",
    "file-report": "Əlavə hesabat təqdim edin",
    "taxpayer-taxreturn-payments": "Ödənişlər",
    "amendment-taxreturn": "Dəyişiklik vergi bəyannaməsi",
    "taxpayer-tax-returns": "Vergi bəyannamələrinin siyahısı",
    "taxpayer-report-details": "Əlavə Hesabatları Siyahıya salın",
    "delegates": "Nümayəndələr",
    "delegate-list": "Nümayəndələrə baxın"
  },
  "delegate": {
    "title": "Nümayəndəni qeydiyyatdan keçirin",
    "description": "Vergi ödəyicisi adına əməliyyat apara biləcək şəxsin məlumatlarını daxil edin.",
    "formTitle": "Nümayəndənin məlumatları",
    "fullName": "Tam ad",
    "fullNamePlaceholder": "Ad və soyad",
    "phoneNumber": "Telefon",
    "phoneNumberPlaceholder": "Telefon nömrəsi",
    "documentNumber": "Sənəd nömrəsi",
    "documentNumberPlaceholder": "Şəxsiyyət sənədi",
    "email": "E-poçt",
    "emailPlaceholder": "E-poçt ünvanı",
    "comments": "Şərhlər",
    "commentsPlaceholder": "Əlavə qeydlər",
    "register": "Nümayəndəni qeydiyyatdan keçirin",
    "successMessage": "Qeydiyyat tamamlandı. Nümayəndəyə aktivləşdirmə e-poçtu göndərildi.",
    "errorMessage": "Nümayəndəni qeydiyyatdan keçirərkən xəta baş verdi. Məlumatları yoxlayıb yenidən cəhd edin.",
    "activationNote": "Nümayəndə parolunu təyin etmək üçün keçid olan e-poçt alacaq. İstifadəçi adı sistem tərəfindən verilmiş ardıcıl koddur.",
    "listTitle": "Qeydiyyatdan keçmiş nümayəndələr",
    "noDelegates": "Hələ nümayəndə qeydiyyatdan keçirməmisiniz",
    "login": "İstifadəçi adı",
    "inactive": "Qeyri-fəal",
    "active": "Fəal",
    "previewDescription": "Sizin nümayəndə istifadəçiləriniz",
    "previewMore": "{{total}} nümayəndədən {{shown}} göstərilir",
    "viewAll": "Hamısına bax"
  }
}
